<template>
  <div class="zlAssess" :class="{ openClass: !isBoolean }">
    <div
      v-if="moduleIsShow == 'true'"
      class="title"
      @click="open('newZlAssess')"
    >
      <span>{{ title }}</span>
      <i class="iconfont icon-right_medium"></i>
    </div>
    <div v-else class="title" @click="open('newZlAssess')">
      <p>
        {{ title }}
        <span
          v-if="moduleAnnotation != ''"
          class="ts-info iconfont icon-zhu"
          @click.stop="isNotes()"
        >
        </span>
      </p>

      <i
        class="iconfont"
        :class="isBoolean ? 'icon-up_medium' : 'icon-down_medium'"
      ></i>
    </div>
    <div v-if="moduleIsShow != 'true'" class="show-box"></div>
    <ZlContent :list="list" v-if="moduleIsShow == 'false'" />
    <!-- 注释弹框 -->
    <Notes ref="child" :notesText="notesText" />
  </div>
</template>
<script>
import ZlContent from "@/components/openClose/ZlContent.vue";
import { getZl } from "@/api/reportQuery";
import { Toast } from "vant";
import { mapState } from "vuex";

import isiOS from "@/utils/iosAn";

export default {
  props: {
    moduleAnnotation: {
      type: String,
    },
    title: {
      type: String,
      default: "样本主要质控",
    },
    moduleIsShow: {
      type: String,
      default: "true",
    },
    templateIsShow: {
      type: String,
      default: "true",
    },
    templateId: {
      type: String,
    },
  },
  components: {
    ZlContent,
  },
  data() {
    return {
      isBoolean: this.templateIsShow == "false" ? false : true,
      notesText: {
        h1: this.title,
        p: this.moduleAnnotation,
      },
      list: [],
    };
  },
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      getZl({
        // labOriginalSampleNo: "W201100a5T",
        // moduleId: 58,
        // productCode: "fwa-p825",

        labOriginalSampleNo: this.publicParams.labOriginalSampleNo,
        productCode: this.publicParams.productId,
        moduleId: this.templateId,
      }).then((res) => {
        this.list = res.data;
      });
    },
    isNotes() {
      if (this.$route.query.userAgent == "wxWeb") {
        this.$refs.child.ishow();
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          name: "notes",
          notesText: this.notesText,
          type: "",
        });
      } else {
        window.android.JSCallNative(
          JSON.stringify({
            name: "notes",
            notesText: this.notesText,
            type: "",
          })
        );
      }
    },

    open(name) {
      if (this.moduleIsShow == "true") {
        let param = {
          name: name,
          moduleId: this.templateId,
          type: "",
        };
        if (this.$route.query.userAgent == "wxWeb") {
          wx.miniProgram.navigateTo({
            url:
              "/packageWebView/pages/new-zia-ssess/new-zia-ssess?moduleId=" +
              this.templateId,
          });
        } else if (isiOS) {
          window.webkit.messageHandlers.JSCallNative.postMessage(param);
        } else {
          window.android.JSCallNative(JSON.stringify(param));
        }
      } else {
        this.isBoolean = !this.isBoolean;
        // Boolean(this.templateIsShow) = !Boolean(this.templateIsShow);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
}
.openClass {
  overflow: hidden;
  height: 70px !important;
  transition: height 1s;
}
.zlAssess {
  background: @background_color;
  border-radius: 10px;
  margin-bottom: 20px;
  font-family: @family;

  .title {
    height: 70px;
    line-height: 70px;
    padding: 0 24px;
    font-size: 18PX;
    font-weight: 500;
    color: #2f354d;
    padding-left: 24px;
    position: relative;
    display: flex;
    justify-content: space-between;
    .ts-info {
      color: #a4a9bf;
      // position: absolute;
    }
  }
}
</style>
